import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AOS from "aos";
import "aos/dist/aos.css";
import OfferTimer from './offertimer';

import step1Img from "../assets/student.png";
import step2Img from "../assets/job.png";
import step3Img from "../assets/fly.png";
import bgImg from "../assets/building.png";
import locationMarker from "../assets/location.png"; // ya jo bhi correct path ho

const steps = [
  {
    image: step1Img,
    title: "1-Year Program",
    subtitle: "Job Ready ✔",
    level: "BEGINNER",
    description: "Quik Start | Job-Ready | Industry Essentials",
    originalPrice: "₹6000",
    discountedPrice: "₹4999",
    hasOffer: true,
    redirectTo: "/job-ready-program", // ✅ Add this
  },
  {
    image: step2Img,
    title: "2-Year Program",
    subtitle: "Deep Skills ✔",
    level: "BEAST",
    description: "Balanced Growth | Skills | Better Packages",
    originalPrice: "₹9000",
    discountedPrice: "₹7999",
    hasOffer: true,
    redirectTo: "/two-year-program", // ✅ Add this
  },
  {
    image: step3Img,
    title: "3-Year Program",
    subtitle: "Leadership Growth ✔",
    level: "BOSS",
    description: "Expert Level| Industry skills | High Salary",
    originalPrice: "₹12000",
    discountedPrice: "₹10999",
    hasOffer: true,
    redirectTo: "/three-year-program", // ✅ Add this
  },
];

const Timeline = styled(Box)({
  position: "relative",
  padding: "0px",
});

const StepCard = styled(Card)(({ align, index }) => {
  const gradients = [
    "linear-gradient(135deg,rgb(190, 185, 185) 0%, #f0f0f0 100%)",
    "linear-gradient(135deg,rgb(190, 185, 185) 0%, #f0f0f0 100%)",
    "linear-gradient(135deg,rgb(190, 185, 185) 0%, #f0f0f0 100%)", 
  ];
  return {
    width: "400px",
    height: "230px",
    background: gradients[index % gradients.length],
    boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
    borderRadius: "28px",
    padding: "40px",
    fontSize: "28px",
    textAlign: align === "left" ? "left" : "right",
    marginRight: align === "left" ? "-100px" : "0",
    marginLeft: align === "right" ? "-80px" : "0",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.03)",
      boxShadow: "0 12px 36px rgba(0,0,0,0.3)",
    },
    "@media (max-width: 768px)": {
      width: "100%",
      height: "auto",
      margin: "0 auto",
      textAlign: "center",
      marginLeft: 0,
      marginRight: 0,
    },
  };
});


const ImageBox = styled("img")(({ align }) => ({
  width: "450px",
  height: "auto",
  borderRadius: "20px",
  margin: align === "left" ? "0 auto 0 0" : "0 0 0 auto",
  marginTop: "40px",
  "@media (max-width: 768px)": {
    width: "100%",
    margin: "0 auto",
  },
}));


const LevelBox = styled(Box)(({ align }) => ({
  position: "absolute",
  left: "64%",
  top: "50%",
  width:"250px",
  transform: "translateY(-50%) rotate(90deg)",
  backgroundColor: "#000",
  color: "#fff",
  padding: "15px 30px",
  borderRadius: "10px",
  fontSize: "28px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "@media (max-width: 768px)": {
    fontSize: "18px",
    left: "50%",
    transform: "translateX(-50%) rotate(0deg)",
    top: "auto",
    bottom: "-30px",
  },
}));


const CurvyRoad = styled("svg")({
  position: "absolute",
  top: "350px",
  left: "50%",
  transform: "translateX(-50%)",
  height: "72%",
  width: "170px",
  zIndex: 0,
});

const TimelineItem = styled(Box)(({ align }) => ({
  display: "flex",
  flexDirection: align === "left" ? "row" : "row-reverse",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "200px",
  position: "relative",
  zIndex: 4,
  gap: "100px",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    gap: "40px",
    marginBottom: "120px",
  },
}));


const BackgroundContainer = styled(Box)({
  background: "white",
  padding: "50px 100px",
});


const RoadLabel = ({ top, text }) => (
  <Box
    sx={{
      position: "absolute",
      top: `${top}%`,
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 6,
      backgroundColor: "#F19F4D",
      color: "black",
      padding: "13px 22px",
      borderRadius: "20px",
      fontWeight: "bold",
      fontSize: "22px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    }}
  >
    {text}
  </Box>
);

const OfferSticker = styled("div")({
  position: "absolute",
  top: "0px",
  right: "0px",
  backgroundColor: "#F9CF00",
  color: "black",
  padding: "12px 18px",
  fontWeight: "bold",
  fontSize: "18px",
  borderRadius: "0px 12px 0px 12px",
  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  zIndex: 10,
  animation: "rotateGlow 3s linear infinite", // added animation here
});


const PriceTag = styled("div")({
  marginTop: "10px",
  fontSize: "18px",
  fontWeight: "bold",
  color: "#000",
});


const LocationPin = ({ top }) => {
  return (
    <img
      src={locationMarker}
      alt="Location Pin"
      style={{
        position: "absolute",
        top: `${top}%`,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100px", // size adjust karna hai to yahan se karo
        height: "auto",
        zIndex: 5,
      }}
    />
  );
};

const EnrollButton = ({ redirectTo }) => {
  const navigate = useNavigate(); // Step 2

  return (
    <Button
      variant="contained"
      sx={{
        mt: 2,
        backgroundColor: "#F19F4D",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#F19F4D",
        },
      }}
      onClick={() => navigate(redirectTo)}
    >
      Enroll Now
    </Button>
  );
};

const Heading = styled("h2")({
  color: "Black",
  fontSize: "46px",
  fontWeight: "bold",
  textAlign: "center",
  padding: "20px 0",
  margin: 0,
  textShadow: "2px 2px 6px rgba(0,0,0,0.4)",
  "@media (max-width: 768px)": {
    fontSize: "32px",
    padding: "60px 0",
  },
});

const FinalText = styled("h2")({
  color: "#000",
  fontSize: "34px",
  fontWeight: "bold",
  textAlign: "center",
  marginTop: "60px",
  zIndex: 1000,
  position: "relative",
  "@media (max-width: 768px)": {
    fontSize: "24px",
  },
});

const CareerPath = () => {
    
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <Box position="relative" overflow="hidden">
      <OfferTimer /> {/* Yaha add karo */}
  
      {/* Background building images */}
      <img
        src={bgImg}
        alt="building1"
        style={{
          position: "absolute",
          top: "2000px",
          left: "0",
          zIndex: 1,
          opacity: 0.4,
        }}
      />
      <img
        src={bgImg}
        alt="building2"
        style={{
          position: "absolute",
          top: "2000px",
          right: "0",
          zIndex: 1,
          opacity: 0.5,
        }}
      />
      <img
        src={bgImg}
        alt="building3"
        style={{
          position: "absolute",
          top: "2000px",
          left: "25%",
          zIndex: 1,
          opacity: 0.6,
        }}
      />
      <img
        src={bgImg}
        alt="building4"
        style={{
          position: "absolute",
          top: "2000px",
          right: "25%",
          zIndex: 1,
          opacity: 0.6,
        }}
      />

      
      <BackgroundContainer>
      <Heading>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
  <h1 style={{ fontSize: "66px", margin: "0", fontWeight: "bold", marginTop: "5px", fontFamily: "Bangers"}}>GyanSetu Pro</h1>
  <p style={{ fontSize: "28px", color: "#555", marginTop: "5px"}}>
    No Matter The Path You Choose, Your Future Begins With Us
  </p>
</div>

      </Heading>
        <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
    
          <CurvyRoad width="160" viewBox="0 0 120 1000" preserveAspectRatio="none">
              <path
              d="M60,0 
              C140,150 -40,300 60,450 
              C140,600 -40,750 105,1105"
              stroke="#333"
              strokeWidth="50"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M60,0 
              C140,150 -40,300 60,450 
              C140,600 -40,750 105,1105"
              stroke="#fff"
              strokeWidth="6"
              strokeDasharray="20,40"
              fill="none"
              strokeLinecap="round"
            />
          </CurvyRoad>

          <RoadLabel top={15} text="Start 🟢" />
          <LocationPin top={22}  />
          <LocationPin top={42} />
          <LocationPin top={75} />
          <RoadLabel top={86} text="Finish 🏁" />

          <Timeline>
            {steps.map((step, index) => {
              const align = index % 2 === 0 ? "left" : "right";
              return (
                <TimelineItem key={index} align={align}>
                  <ImageBox
                    src={step.image}
                    alt={step.title}
                    align={align}
                    data-aos={align === "left" ? "fade-right" : "fade-left"}
                  />

<StepCard align={align} index={index} data-aos="fade-up">
<OfferSticker>
  20% OFF
</OfferSticker>

    
<CardContent
  style={{
    textAlign: "left",       // 🔥 This aligns text to the left
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // 🔥 Ensures child items like buttons also stay left
  }}
>
<Typography
  variant="h5"
  fontWeight="bold"
  gutterBottom
  sx={{ color: "#2d2d2d", mb: 1 }}
>
  {step.title}
</Typography>

                      <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ color: "#3f3f3f", mb: 1 }}
                      >
                        {step.subtitle}
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{
                          color: "#222",
                          mt: 2,
                          lineHeight: 2.0,
                          fontSize: "18px",
                        }}
                      >
                        {step.description}
                      </Typography>
                      
                      {step.hasOffer && (
  <PriceTag>
  <span
    style={{
      textDecoration: "line-through",
      color: "gray",
      marginRight: "10px",
      fontSize: "22px",
    }}
  >
    {step.originalPrice}
  </span>
  <span style={{ color: "#e74c3c", fontSize: "24px" }}>
    {step.discountedPrice}
  </span>
</PriceTag>

)}

<EnrollButton redirectTo={step.redirectTo} />

                   </CardContent>
                    <LevelBox align={align}>{step.level}</LevelBox>
                  </StepCard>
                </TimelineItem>
              );
            })}
          </Timeline>

          <FinalText data-aos="zoom-in">✨ What are you waiting for? ✨</FinalText>
        </Container>
      </BackgroundContainer>
    </Box>
  );
};

export default CareerPath;
